import React from 'react'
import CanvasJSReact from '@canvasjs/react-charts';

var CanvasJSChart = CanvasJSReact.CanvasJSChart;

function DoughnutChart({ monthly, today, yearly, singleAuction }) {
    const options = {
        animationEnabled: true,
        useHTML: true,
        subtitles: [{

            verticalAlign: "center",
            fontSize: 24,

        }],

   
        data: [{
            type: "doughnut",
            
            innerRadius: "70%",
            yValueFormatString: "#,###'%'",
            dataPoints: [
                { y: today, color: "#F32F45" },
                { y: yearly, color: "#F9C114" },
                { y: monthly, color: "#043BC7" },
                // One-time single-auction purchases. Without their own slice they would be
                // invisible here while still counting towards the total shown beside the chart.
                { y: singleAuction, color: "#1E9E62" },
            ]

        }],

    }

    return (

        <div className="doughnut-chart-container">
            <CanvasJSChart options={options} />

        </div>
    )
}

export default DoughnutChart

